import { useInteractionStore } from '@/store/interactionStore';
import { useEngine } from '@/app/EngineContext';
import { boundsCenter } from '@/core/geometry/bounds';
import styles from './SpatialCanvas.module.css';

/** Rubber band from the source object to the pointer while connecting. */
export const ConnectPreview = () => {
  const preview = useInteractionStore((s) => s.connect);
  const { scene } = useEngine();
  if (!preview) return null;
  const from = scene.boundsOf(preview.sourceId);
  if (!from) return null;
  const a = boundsCenter(from);
  const target = preview.targetId ? scene.boundsOf(preview.targetId) : undefined;
  const b = target ? boundsCenter(target) : preview.to;
  return (
    <svg className={styles.connectPreview} data-testid="connect-preview" data-target={preview.targetId ?? undefined}>
      <line x1={a.x} y1={a.y} x2={b.x} y2={b.y} />
    </svg>
  );
};
